import { axiosInstance } from "../pages/auth/auth.context";
import { AxiosResponse } from "axios";

export interface UserPositionRequestDTO {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  positionId: string;
  positionName: string;
  positionTableName: string;
  createdDate: string;
  createdBy: string;
}

export interface CreatePositionRequestDTO {
  positionId: string;
  userId?: string;
}

class PositionRequestService {
  private handleError(error: any): never {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }

  /**
   * Get position requests for the current authenticated user
   */
  async getMyPositionRequests(): Promise<UserPositionRequestDTO[]> {
    try {
      const response: AxiosResponse<UserPositionRequestDTO[]> =
        await axiosInstance.get("position-requests");
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  /**
   * Get all position requests from all users (admin only)
   */
  async getAllPositionRequests(): Promise<UserPositionRequestDTO[]> {
    try {
      const response: AxiosResponse<UserPositionRequestDTO[]> =
        await axiosInstance.get("position-requests/admin");
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  /**
   * Create a new position request
   */
  async createPositionRequest(
    request: CreatePositionRequestDTO,
  ): Promise<UserPositionRequestDTO> {
    try {
      const response: AxiosResponse<UserPositionRequestDTO> =
        await axiosInstance.post("position-requests", request);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  /**
   * Delete a position request by ID
   */
  async deletePositionRequest(id: string): Promise<void> {
    try {
      await axiosInstance.delete(`position-requests/${id}`);
    } catch (error) {
      this.handleError(error);
    }
  }
}

// Export singleton instance
export const positionRequestService = new PositionRequestService();
